<template>
  <div
    class="flex flex-col section-y bg-stone-50"
    :class="[twMerge(content?.background === 'dark' && 'bg-teal-900')]"
  >
    <div class="max-w-(--breakpoint-xl) m-auto px-4 w-full">
      <Heading
        h-class="section-title"
        :level="2"
        :title="content.title"
        :description="content?.subtitle"
        :use-h-tag="false"
        class="mb-4 kft-product-showcase__heading kft-heading--left"
      />
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div
          v-for="plan in content.pricingPlan"
          :key="plan?.pricingPlanKey"
          class="bg-white p-4 rounded-3xl shadow-xl"
        >
          <h5 class="text-center text-lg font-bold">{{ plan?.title }}</h5>
          <span class="text-center block text-gray-400 font-bold mb-8">{{
            plan?.subtitle
          }}</span>
          <div
            v-for="feature in plan?.pricingFeature"
            :key="feature?.featureDescription"
            class="flex gap-4 justify-between py-2"
          >
            <span
              class="text-primary text-sm"
              :class="{ 'line-through': !feature?.enabled }"
              >{{ feature?.featureDescription }}</span
            >
            <span
              ><IconCircleCheck
                class="text-primary"
                :class="{
                  hidden: !feature?.enabled,
                }"
            /></span>
          </div>
          <Button
            class="w-full mt-8 font-bold align-self-end"
            :variant="plan?.highlight ? 'contained' : 'outlined'"
            @click="handlePlanClick(plan)"
            >{{ plan.CTA.label }}</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import IconCircleCheck from '~/components/icons/IconCircleCheck'
const emit = defineEmits(['openContactForm'])
const { content = {} } = defineProps<{ content: any }>()

const handlePlanClick = (plan: any) => {
  if (plan?.CTA?.url) {
    // If URL exists, navigate to it
    navigateTo(plan.CTA.url, { external: true })
  } else {
    // Otherwise, open the contact form modal
    emit('openContactForm', plan?.pricingPlanKey)
  }
}
</script>
<style lang="css" scoped></style>
